import axios from "axios";
import { API_URL as BASE_URL } from "../../config/env";

const isDev = process.env.NODE_ENV !== "production";

// Dev-only: log every open-vending response (success or error) with its shape.
const logged = (label, request) =>
  request.then(
    (res) => {
      if (isDev) console.log(`[open-vending] ${label} ->`, res.status, res.data);
      return res.data;
    },
    (err) => {
      if (isDev) {
        console.error(
          `[open-vending] ${label} failed ->`,
          err.response?.status,
          err.response?.data ?? err.message
        );
      }
      throw err;
    }
  );

export const getOpenVendingMeter = (meterId) =>
  logged(
    "GET /metering/open-vending/meter",
    axios.get(`${BASE_URL}/metering/open-vending/meter`, { params: { meterId } })
  );

export const createOpenVendingSession = ({ meterId, name, email, amount }) =>
  logged(
    "POST /metering/open-vending/session",
    axios.post(`${BASE_URL}/metering/open-vending/session`, {
      meterId,
      name,
      email,
      amount,
    })
  );

// Backend allows one confirm call per 30 seconds per session.
export const confirmOpenVendingPayment = (sessionId) =>
  logged(
    "POST /metering/open-vending/confirm",
    axios.post(`${BASE_URL}/metering/open-vending/confirm`, { sessionId })
  );

// For people who already paid but lost/never saw their token.
export const retrieveOpenVendingToken = ({ meterId, accountNumber }) =>
  logged(
    "POST /metering/open-vending/retrieve",
    axios.post(`${BASE_URL}/metering/open-vending/retrieve`, { meterId, accountNumber })
  );
